/**
 * Bandeau persistant sur le dashboard pour les coachs FREE :
 *  - FREE actif   : bandeau gold "Ton essai expire le X juin 2026" + CTA Coach+
 *  - FREE expire  : bandeau rouge sticky "Ton essai est termine" + CTA Coach+
 *  - Plans payes  : null (pas affiche)
 *
 * Usage : <FreeExpiryBanner /> en haut du DashboardLayout, avant le contenu.
 */
import { useNavigate } from 'react-router-dom'
import { Clock, AlertTriangle, ArrowRight } from 'lucide-react'
import { useFreeStatus } from '../hooks/useFreeStatus'
import { T } from '../theme'

export default function FreeExpiryBanner() {
  const navigate = useNavigate()
  const { isFreeUser, isExpired, daysLeft, formattedExpiresAt } = useFreeStatus()

  if (!isFreeUser || !formattedExpiresAt) return null

  const handleUpgrade = () => navigate('/tarifs')

  if (isExpired) {
    return (
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: '#7f1d1d', color: '#fff',
        borderBottom: `1px solid rgba(255,255,255,0.1)`,
        padding: '10px 18px',
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <AlertTriangle size={16} color="#fecaca" style={{ flexShrink: 0 }} />
          <span style={{
            fontFamily: T.mono, fontSize: 11, letterSpacing: '.04em', lineHeight: 1.45,
          }}>
            Ton essai Free est terminé le <strong>{formattedExpiresAt}</strong>.
            Passe en Coach+ pour continuer à créer et modifier.
          </span>
        </div>
        <button
          type="button"
          onClick={handleUpgrade}
          style={{
            padding: '8px 14px',
            background: T.gold, color: T.dark, border: 'none',
            fontFamily: T.mono, fontSize: 10, fontWeight: 700,
            letterSpacing: '.12em', textTransform: 'uppercase',
            cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6,
            flexShrink: 0,
          }}
        >
          Passer en Coach+ <ArrowRight size={11} />
        </button>
      </div>
    )
  }

  // Free actif : bandeau persistant. Severite visuelle augmente a J-7
  // (gold doux -> orange) pour signaler l'urgence sans spammer.
  if (daysLeft == null) return null

  const isUrgent = daysLeft <= 7
  const accent = isUrgent ? T.orange : T.gold
  const accentBdr = isUrgent ? T.orangeBdr : T.goldBdr
  const accentBg = isUrgent ? T.orangeBg : 'rgba(79,142,247,0.10)'

  const daysLabel = daysLeft <= 0
    ? "aujourd'hui"
    : daysLeft === 1 ? 'demain' : `dans ${daysLeft} jours`

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: accentBg, color: T.ink,
      borderBottom: `1px solid ${accentBdr}`,
      padding: '10px 18px',
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      justifyContent: 'space-between',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Clock size={15} color={accent} style={{ flexShrink: 0 }} />
        <span style={{
          fontFamily: T.mono, fontSize: 11, letterSpacing: '.04em', lineHeight: 1.45,
        }}>
          Ton essai Free expire <strong style={{ color: accent }}>{daysLabel}</strong> ({formattedExpiresAt}).
          Passe en Coach+ pour ne rien perdre.
        </span>
      </div>
      <button
        type="button"
        onClick={handleUpgrade}
        style={{
          padding: '7px 12px',
          background: T.gold, color: T.dark, border: 'none',
          fontFamily: T.mono, fontSize: 10, fontWeight: 700,
          letterSpacing: '.12em', textTransform: 'uppercase',
          cursor: 'pointer',
          display: 'inline-flex', alignItems: 'center', gap: 6,
          flexShrink: 0,
        }}
      >
        Passer en Coach+ <ArrowRight size={11} />
      </button>
    </div>
  )
}
